import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { isEmpty, isNone } from '@ember/utils';
import Controller from '@ember/controller';
import { CAMPAIGN_SETUP_STEPS, DEFAULT_CAMPAIGN_SETUP_STEPS } from 'cio/utils/campaign-navigation';
import { CampaignType } from 'cio/models/campaign';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';

export default class TriggerController extends Controller {
  @service router;

  navSteps = DEFAULT_CAMPAIGN_SETUP_STEPS;
  steps = CAMPAIGN_SETUP_STEPS;

  @readOnly('steps.default_workflow') nextStep;

  disabledNavigationTooltipContent = 'You must set up your trigger before moving on to the next step';

  @computed('model.{type,anchors,event}')
  get hasValidSetup() {
    let { type, anchors, event } = this.model;

    if (isNone(type)) {
      return false;
    }

    if (type === CampaignType.Behavioral) {
      return !isEmpty(anchors);
    }

    if (type === CampaignType.Transactional) {
      return !isEmpty(event);
    }

    return false;
  }

  _createCampaign = task(
    {
      drop: true,
    },
    async () => {
      let campaign = await this.model.save();
      this.router.transitionTo(this.nextStep.path, campaign.id);
    },
  );

  _deleteCampaign = task(
    {
      drop: true,
    },
    async () => {
      await this.model.deleteRecord();
      this.router.transitionTo('campaigns.index');
    },
  );
}
